module.exports = __webpack_public_path__ + "public/media/deltaelnile.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/deltaelnile.png
// module id = ./images/partners/deltaelnile.png
// module chunks = 0